import React from 'react'
import './HP_language.scss'

function HP_language() {
  return (
    <div>HP_language</div>
  )
}

export default HP_language